import { Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { selectedUser } from '../../features/auth/authSlice';
import { useAppSelector } from '../../hooks/redux/hooks';
import Sidebar from '../Sidebar/Sidebar';

const DashboardLayout = () => {
    const { identity } = useAppSelector(selectedUser);
    
    return (
        <Container fluid className="g-0">
            <Row className="g-0">
                <Col className="col-1 col-sm-1 col-md-1 col-lg-2 bg-primary sidebar px-sm-1 px-lg-3 py-4">
                    <Sidebar identity={identity} />
                </Col>
                <Col className="col-11 col-sm-11 col-md-11 col-lg-10 ms-auto" >
                    <Outlet />
                </Col>
            </Row>
        </Container>
    )
}

export default DashboardLayout